<template>
  <div>
    <!-- 订单详情标签匹配；不与配送单组件共用。 -->
    <el-dialog :title="$t('message.tagMatching')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="480px" center>
      <div class="content" v-if="isNormal">
        <div class="row">
          <div class="label">{{ $t("message.tagType") }}：</div>
          <div class="val">
            <el-select v-model="datas.type" placeholder="请选择" filterable>
              <el-option v-for="item in options" :key="item.value" :label="item.key" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="label">text文件：</div>
          <div class="val">
            <!-- 未上传时显示拖拽区域；上传成功后切换为文件信息。 -->
            <el-upload v-if="!uploadedFile" class="upload-demo" drag
              :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-else class="uploaded-file">
              <i class="el-icon-document"></i>
              <span :title="uploadedFile">{{ uploadedFile }}</span>
              <el-button type="text" icon="el-icon-close" title="删除文件" @click="clearUploadedFile"></el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="normal" v-else>
        <div v-for="(item, index) in textList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isNormal">
        <el-button @click="dialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <el-button type="primary" @click="save">{{ $t("message.ok") }}</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <el-button type="success" @click="copyText">{{ $t("message.copy") }}</el-button>
        <el-button type="primary" @click="dialogVisible = false">{{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    selectedList: { type: Array, default: () => [] },
    saveHandler: { type: Function, default: null },
  },
  data() {
    return {
      options: [
        { key: '亚马逊FBA', value: 'FBA' },
        { key: '乐天', value: 'LETIAN' },
        { key: 'RAKU', value: 'RAKU' },
        { key: '雅虎', value: 'YAHU' },
        { key: 'ZOZO', value: 'ZOZO' },
      ],
      datas: { type: '', file_path: '', order_detail_id_set: [] },
      uploadedFile: '',
      dialogVisible: false,
      isNormal: true,
      textList: [],
    }
  },
  watch: {
    dialogVisible(value) {
      if (value) this.isNormal = true
    },
  },
  methods: {
    // 订单详情只提交 order.tag.textMatch 所需字段。
    save() {
      if (!this.datas.type) return this.$message.error('未选择标签列表')
      if (!this.datas.file_path) return this.$message.error('未上传标签文件')
      if (!this.saveHandler) return
      const data = {
        file: this.uploadedFile,
        file_path: this.datas.file_path,
        type: this.datas.type,
        order_detail_id_set: this.selectedList.map(item => item.id),
      }
      Promise.resolve(this.saveHandler(data)).then(res => {
        this.datas = { type: '', file_path: '', order_detail_id_set: [] }
        this.uploadedFile = ''
        if (res && res.data === false) return
        this.textList = res && res.data ? res.data : []
        this.isNormal = false
      }).catch(() => {})
    },
    beforeAvatarUpload(file) {
      const isText = file.type === 'text/plain'
      const isXlsm = file.name.split('.')[1] === 'xlsm'
      if (!isText && !isXlsm) this.$message.error('上传格式只能是text/plain,xlsm!')
      return isText || isXlsm
    },
    // 上传接口成功后同时保存服务端路径和原始文件名，用于提交及页面回显。
    handleAvatarSuccess(response, file) {
      this.datas.file_path = response.data
      this.uploadedFile = file.name
      this.$message.success('上传成功')
    },
    // 删除当前文件后恢复上传区域，允许重新选择文件。
    clearUploadedFile() {
      this.datas.file_path = ''
      this.uploadedFile = ''
    },
    copyText() {
      this.copy(this.textList.join('\n') + (this.textList.length ? '\n' : ''))
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 15px;
  .row { display: flex; margin-bottom: 20px; }
  .label { line-height: 40px; flex: 1; }
  .val { flex: 3; }
  /deep/.el-select { width: 80%; .el-input { width: 100%; } }
  /deep/.el-upload-dragger { width: 250px; }
  .uploaded-file {
    display: flex;
    align-items: center;
    width: 250px;
    min-height: 48px;
    padding: 0 12px;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #f5f7fa;

    > i {
      margin-right: 8px;
      color: #409eff;
      font-size: 20px;
    }

    span {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      color: #606266;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.normal { max-height: 500px; overflow-y: auto; div { margin-bottom: 5px; } }
</style>
